// import React from 'react';
// import Icon from '../../../components/AppIcon';

// const MarketSelection = ({ selectedMarket, onMarketSelect }) => {
//   const markets = [
//     {
//       id: 'spot',
//       title: 'Spot Trading',
//       description: 'Trade actual cryptocurrencies with immediate settlement',
//       features: ['No leverage', 'Own actual assets', 'Lower risk', 'Beginner friendly'],
//       icon: 'Coins',
//       recommended: false
//     },
//     {
//       id: 'future',
//       title: 'Future Trading',
//       description: 'Trade contracts with leverage for amplified returns',
//       features: ['Up to 125x leverage', 'Long & short positions', 'Higher returns', 'Advanced trading'],
//       icon: 'TrendingUp',
//       recommended: true
//     }
//   ];

//   return (
//     <div className="space-y-6">
//       <div className="text-center">
//         <h3 className="text-2xl font-bold text-foreground mb-2">Select Trading Market</h3>
//         <p className="text-muted-foreground">Choose the market type for your trading bot</p>
//       </div>

//       <div className="grid md:grid-cols-2 gap-6">
//         {markets?.map((market) => {
//           const isDisabled = !market?.recommended;

//           return (
//             <div
//               key={market?.id}
//               // Core classes
//               className={`
//                 relative p-6 border-2 rounded-xl transition-all duration-200
//                 ${isDisabled 
//                   ? 'opacity-60 cursor-not-allowed' 
//                   : 'cursor-pointer hover:border-primary/70 hover:shadow-md hover:scale-[1.02]'
//                 }
//                 ${selectedMarket === market?.id && !isDisabled
//                   ? 'border-primary bg-primary/5'
//                   : 'border-border bg-card'
//                 }
//               `}
//               // Only allow click if not disabled
//               onClick={() => !isDisabled && onMarketSelect(market?.id)}
//               // Optional: Tooltip on hover
//               title={isDisabled ? 'Only recommended markets are available' : market?.title}
//             >
//               {/* Recommended Badge */}
//               {market?.recommended && (
//                 <div className="absolute -top-3 left-4 bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs font-medium">
//                   Recommended
//                 </div>
//               )}

//               {/* Visual Disabled Overlay */}
//               {isDisabled && (
//                 <div className="absolute inset-0 rounded-xl bg-muted/30 pointer-events-none" />
//               )}

//               {/* Content */}
//               <div className="flex items-start space-x-4 relative z-10">
//                 {/* Icon */}
//                 <div
//                   className={`w-12 h-12 rounded-lg flex items-center justify-center transition-colors ${
//                     selectedMarket === market?.id && !isDisabled
//                       ? 'bg-primary text-primary-foreground'
//                       : 'bg-muted text-muted-foreground'
//                   }`}
//                 >
//                   <Icon name={market?.icon} size={24} />
//                 </div>

//                 {/* Text Content */}
//                 <div className="flex-1">
//                   <h4 className={`text-lg font-semibold mb-2 ${isDisabled ? 'text-muted-foreground' : 'text-foreground'}`}>
//                     {market?.title}
//                   </h4>
//                   <p className="text-muted-foreground text-sm mb-4">
//                     {market?.description}
//                   </p>

//                   <div className="space-y-2">
//                     {market?.features?.map((feature, index) => (
//                       <div key={index} className="flex items-center space-x-2">
//                         <Icon name="Check" size={16} className="text-success" />
//                         <span className={`text-sm ${isDisabled ? 'text-muted-foreground/70' : 'text-foreground'}`}>
//                           {feature}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Radio Button */}
//                 <div
//                   className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${
//                     selectedMarket === market?.id && !isDisabled
//                       ? 'border-primary bg-primary'
//                       : 'border-border'
//                   }`}
//                 >
//                   {selectedMarket === market?.id && !isDisabled && (
//                     <div className="w-2 h-2 bg-primary-foreground rounded-full" />
//                   )}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* Info Box */}
//       <div className="bg-muted/50 border border-border rounded-lg p-4">
//         <div className="flex items-start space-x-3">
//           <Icon name="Info" size={20} className="text-primary mt-0.5" />
//           <div>
//             <h5 className="font-medium text-foreground mb-1">Market Selection Tips</h5>
//             <p className="text-sm text-muted-foreground">
//               Spot trading is recommended for beginners as it involves lower risk and no liquidation concerns. 
//               Futures trading offers higher profit potential but requires advanced risk management skills.
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MarketSelection;

import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketSelection = ({ selectedMarket, onMarketSelect }) => {
  const markets = [
    {
      id: 'spot',
      title: 'Spot Trading',
      description: 'Trade actual cryptocurrencies with immediate settlement',
      features: ['No leverage', 'Own actual assets', 'Lower risk', 'Beginner friendly'],
      icon: 'Coins',
      recommended: false
    },
    {
      id: 'future',
      title: 'Future Trading',
      description: 'Trade contracts with leverage for amplified returns',
      features: ['Up to 125x leverage', 'Long & short positions', 'Higher returns', 'Advanced trading'],
      icon: 'TrendingUp',
      recommended: true
    }
  ];

  return (
    <div className="w-full max-w-5xl mx-auto px-0 sm:px-6 lg:px-8 py-0 sm:py-12">
      {/* Header */}
      <div className="text-center mb-8 sm:mb-12">
        <h3 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
          Select Trading Market
        </h3>
        <p className="text-muted-foreground text-sm sm:text-base max-w-2xl mx-auto">
          Choose the market type for your trading bot
        </p>
      </div>

      {/* Market Cards - Responsive Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {markets.map((market) => {
          const isDisabled = !market.recommended;
          const isSelected = selectedMarket === market.id && !isDisabled;

          return (
            <div
              key={market.id}
              onClick={() => !isDisabled && onMarketSelect(market.id)}
              className={`
                relative p-6 sm:p-8 border-2 rounded-2xl transition-all duration-300 select-none
                ${isDisabled 
                  ? 'opacity-60 cursor-not-allowed' 
                  : 'cursor-pointer hover:border-primary/70 hover:shadow-lg hover:scale-[1.02] hover:-translate-y-1'
                }
                ${isSelected
                  ? 'border-primary bg-primary/5 shadow-lg'
                  : 'border-border bg-card shadow-sm'
                }
              `}
              role="radio"
              aria-checked={isSelected}
              aria-disabled={isDisabled}
              tabIndex={isDisabled ? -1 : 0}
              onKeyDown={(e) => e.key === 'Enter' && !isDisabled && onMarketSelect(market.id)}
              title={isDisabled ? 'Only recommended markets are available in this version' : market.title}
            >
              {/* Recommended Badge */}
              {market.recommended && (
                <div className="absolute -top-3 left-6 sm:left-8 bg-primary text-primary-foreground px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold shadow-md z-20">
                  Recommended
                </div>
              )}

              {/* Disabled Overlay */}
              {isDisabled && (
                <div className="absolute inset-0 rounded-2xl bg-muted/40 pointer-events-none z-10" />
              )}

              {/* Content */}
              <div className="relative z-10 flex flex-col sm:flex-row items-start gap-4 sm:gap-6">
                {/* Icon */}
                <div
                  className={`
                    w-14 h-14 sm:w-16 sm:h-16 rounded-xl flex items-center justify-center flex-shrink-0 transition-all
                    ${isSelected ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'}
                  `}
                >
                  <Icon name={market.icon} size={28} />
                </div>

                {/* Text Content */}
                <div className="flex-1 min-w-0">
                  <h4 className={`text-xl sm:text-2xl font-bold mb-2 ${isDisabled ? 'text-muted-foreground' : 'text-foreground'}`}>
                    {market.title}
                  </h4>
                  <p className="text-muted-foreground text-sm sm:text-base mb-5 leading-relaxed">
                    {market.description}
                  </p>

                  {/* Features List */}
                  <div className="space-y-2.5">
                    {market.features.map((feature, index) => (
                      <div key={index} className="flex items-center gap-3">
                        <Icon name="Check" size={18} className="text-success flex-shrink-0" />
                        <span className={`text-sm sm:text-base ${isDisabled ? 'text-muted-foreground/70' : 'text-foreground/90'}`}>
                          {feature}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Radio Indicator */}
                <div
                  className={`
                    w-7 h-7 sm:w-8 sm:h-8 rounded-full border-3 flex items-center justify-center flex-shrink-0 transition-all mt-1 sm:mt-0
                    ${isSelected ? 'border-primary bg-primary' : 'border-border'}
                  `}
                >
                  {isSelected && (
                    <div className="w-3 h-3 bg-primary-foreground rounded-full" />
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Info Box - Responsive */}
      <div className="mt-10 sm:mt-12 bg-muted/50 border border-border rounded-2xl p-5 sm:p-6 max-w-4xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start gap-4">
          <div className="flex-shrink-0">
            <Icon name="Info" size={24} className="text-primary" />
          </div>
          <div>
            <h5 className="font-semibold text-foreground text-lg mb-2">Market Selection Tips</h5>
            <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
              <strong>Spot trading</strong> is recommended for beginners as it involves lower risk and no liquidation concerns. 
              You own the actual assets with immediate settlement.<br /><br />
              <strong>Futures trading</strong> offers higher profit potential with leverage (up to 125x), but comes with 
              increased risk including liquidation. Suitable for experienced traders with strong risk management.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketSelection;